/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { useTheme } from "react-jss";
import classnames from "classnames";
import { FontAwesomeIcon } from "../../shared/FontAwesome";
import useStyles from "./StarRatingRenderer.styles";
import { RendererProps } from "../BaseRenderer";
import useQuestion from "../../../hooks/useQuestion";
import { useKeyboardNavigation } from "../../../hooks/useKeyboardNavigation";
import { StarRatingNavigation } from "../../controls/KeyboardNavigation/StarRatingNavigation";

interface Props extends RendererProps {
    index: number;
    setValue(value: number, reset?: boolean): void;
    value: number;
    elementId: string;
    split: number;
    starWidth?: number;
    starHeight?: number;
    isDisabled?: boolean;
    rerenderParentCallback(input: number): void;
    hoveredStarValue: number;
}

export default function StarRenderer(props: Props) {
    const {
        index,
        setValue,
        value,
        elementId,
        split = 1,
        starWidth = 24,
        starHeight = 24,
        isDisabled = false,
        variable,
        rerenderParentCallback,
        hoveredStarValue,
    } = props;

    const question = useQuestion();
    const theme = useTheme();
    const spaceKeyCallBack = () => {
        if (!isDisabled) {
            setValue(starValue);
        }
    };
    const starUniqueId = `${elementId}_INPUT_${index}`;
    const { elementReference, onKeyDown } = useKeyboardNavigation(
        starUniqueId,
        variable,
        question,
        StarRatingNavigation,
        spaceKeyCallBack,
    );

    const starValue = (index + 1) / split;
    const splitWidth = starWidth / split;
    const isIconHighlighted =
        hoveredStarValue > 0 ? starValue <= hoveredStarValue : starValue <= value;
    const classes = useStyles({ theme, starWidth, starHeight, splitWidth });

    return (
        <div
            onKeyDown={onKeyDown}
            ref={elementReference}
            onClick={isDisabled ? undefined : () => setValue(starValue)}
            onMouseOver={isDisabled ? undefined : () => rerenderParentCallback(starValue)}
            className={`${classnames(classes.starRatingStar)} ${
                isDisabled ? classes.disabled : ""
            }`}
            aria-label={starValue.toString()}
            // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
            role="radio"
            tabIndex={0}
            aria-checked={isIconHighlighted}
        >
            <FontAwesomeIcon
                style={{
                    position: "absolute",
                    width: starWidth,
                    height: starHeight,
                    left: index % split === 0 ? 0 : undefined,
                    right: index % split === 1 ? 0 : undefined,
                }}
                icon={[isIconHighlighted ? "fas" : "far", "star"]}
            />
        </div>
    );
}
